export interface CategoryItem {
  id: string;
  nameKey: string;
  url: string;
  image: string;
  icon: string;
}

export const MAIN_SITE_URL = "https://kaspreadsheet.com";

export const categories: CategoryItem[] = [
  {
    id: "shoes",
    nameKey: "category.shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20single%20stylish%20white%20and%20grey%20running%20sneaker%20standing%20upright%20on%20a%20smooth%20light%20grey%20concrete%20surface%2C%20soft%20directional%20daylight%2C%20subtle%20shadows%2C%20clean%20minimal%20editorial%20ecommerce%20product%20photography%2C%20cool%20neutral%20palette%2C%20crisp%20fabric%20texture%2C%20high%20detail&width=600&height=400&seq=usfans-cat-shoes-v2&orientation=landscape&nocache=true",
    icon: "ri-footprint-line",
  },
  {
    id: "hoodies",
    nameKey: "category.hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20thick%20burgundy%20maroon%20oversized%20hoodie%20folded%20neatly%20on%20a%20warm%20taupe%20wooden%20table%2C%20soft%20window%20light%2C%20cozy%20editorial%20product%20photography%2C%20rich%20deep%20red%20fabric%20texture%2C%20minimal%20background%2C%20high%20detail&width=600&height=400&seq=usfans-cat-hoodie-v2&orientation=landscape&nocache=true",
    icon: "ri-shirt-line",
  },
  {
    id: "tshirts",
    nameKey: "category.tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20crisp%20navy%20blue%20cotton%20t-shirt%20on%20a%20slim%20wooden%20hanger%20against%20a%20soft%20white%20studio%20wall%2C%20gentle%20natural%20side%20light%2C%20minimal%20clean%20ecommerce%20photography%2C%20deep%20blue%20fabric%2C%20subtle%20wrinkle%20detail%2C%20high%20detail&width=600&height=400&seq=usfans-cat-tshirt-v2&orientation=landscape&nocache=true",
    icon: "ri-t-shirt-line",
  },
  {
    id: "jackets",
    nameKey: "category.jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=An%20olive%20green%20utility%20field%20jacket%20displayed%20flat%20on%20a%20light%20stone%20grey%20background%2C%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20muted%20military%20green%20canvas%20texture%20with%20visible%20pockets%20and%20stitching%2C%20high%20detail&width=600&height=400&seq=usfans-cat-jacket-v2&orientation=landscape&nocache=true",
    icon: "ri-t-shirt-air-line",
  },
  {
    id: "pants",
    nameKey: "category.pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20pair%20of%20charcoal%20grey%20tailored%20trousers%20neatly%20folded%20on%20a%20warm%20birch%20wood%20surface%2C%20soft%20window%20daylight%2C%20minimal%20editorial%20ecommerce%20photography%2C%20dark%20neutral%20fabric%20with%20crease%20lines%2C%20high%20detail&width=600&height=400&seq=usfans-cat-pants-v2&orientation=landscape&nocache=true",
    icon: "ri-pantone-line",
  },
  {
    id: "headwear",
    nameKey: "category.headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20black%20structured%20baseball%20cap%20on%20a%20clean%20warm%20beige%20studio%20backdrop%2C%20soft%20diffused%20light%2C%20minimal%20editorial%20product%20photography%2C%20dark%20matte%20fabric%20with%20subtle%20embroidery%2C%20high%20detail&width=600&height=400&seq=usfans-cat-headwear-v2&orientation=landscape&nocache=true",
    icon: "ri-user-star-line",
  },
  {
    id: "sets",
    nameKey: "category.sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20matching%20terracotta%20clay%20colored%20athleisure%20hoodie%20and%20jogger%20set%20laid%20flat%20together%20on%20a%20soft%20sand%20background%2C%20gentle%20natural%20light%2C%20minimal%20editorial%20ecommerce%20photography%2C%20warm%20earthy%20tones%2C%20high%20detail%20fabric&width=600&height=400&seq=usfans-cat-sets-v2&orientation=landscape&nocache=true",
    icon: "ri-stack-line",
  },
  {
    id: "underwear",
    nameKey: "category.underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20set%20of%20soft%20white%20and%20mint%20green%20cotton%20underwear%20neatly%20folded%20on%20a%20pale%20pastel%20surface%2C%20soft%20diffused%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20fresh%20clean%20tones%2C%20high%20detail&width=600&height=400&seq=usfans-cat-underwear-v2&orientation=landscape&nocache=true",
    icon: "ri-inbox-line",
  },
  {
    id: "jersey",
    nameKey: "category.jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20folded%20red%20and%20white%20striped%20sports%20jersey%20with%20a%20subtle%20number%20print%20on%20a%20light%20grey%20studio%20background%2C%20soft%20natural%20lighting%2C%20minimal%20editorial%20product%20photography%2C%20vivid%20team%20colors%2C%20high%20detail&width=600&height=400&seq=usfans-cat-jersey-v2&orientation=landscape&nocache=true",
    icon: "ri-medal-line",
  },
  {
    id: "accessories",
    nameKey: "category.accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20gold%20wristwatch%20with%20a%20brown%20leather%20strap%20resting%20beside%20a%20pair%20of%20sunglasses%20on%20a%20warm%20stone%20surface%2C%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20warm%20metallic%20tones%2C%20high%20detail&width=600&height=400&seq=usfans-cat-accessories-v2&orientation=landscape&nocache=true",
    icon: "ri-vip-diamond-line",
  },
  {
    id: "bags",
    nameKey: "category.bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20cognac%20brown%20leather%20backpack%20standing%20upright%20on%20a%20light%20neutral%20studio%20background%2C%20soft%20diffused%20natural%20light%2C%20editorial%20product%20photography%2C%20rich%20warm%20brown%20leather%20grain%2C%20high%20detail&width=600&height=400&seq=usfans-cat-bags-v2&orientation=landscape&nocache=true",
    icon: "ri-shopping-bag-line",
  },
  {
    id: "belts",
    nameKey: "category.belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20coiled%20black%20leather%20belt%20with%20a%20brushed%20metal%20buckle%20on%20a%20clean%20light%20grey%20surface%2C%20soft%20natural%20lighting%2C%20minimal%20editorial%20product%20photography%2C%20dark%20leather%20texture%2C%20high%20detail&width=600&height=400&seq=usfans-cat-belts-v2&orientation=landscape&nocache=true",
    icon: "ri-scissors-line",
  },
  {
    id: "perfumes",
    nameKey: "category.perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=An%20amber%20glass%20perfume%20bottle%20with%20warm%20golden%20liquid%20on%20a%20light%20stone%20surface%2C%20soft%20natural%20light%20with%20a%20subtle%20reflection%2C%20editorial%20product%20photography%2C%20warm%20honey%20tones%2C%20high%20detail&width=600&height=400&seq=usfans-cat-perfume-v2&orientation=landscape&nocache=true",
    icon: "ri-drop-line",
  },
  {
    id: "other",
    nameKey: "category.other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%20flat%20lay%20of%20assorted%20lifestyle%20items%20including%20a%20matte%20black%20water%20bottle%2C%20metal%20keychain%20and%20card%20holder%20on%20a%20light%20neutral%20surface%2C%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20mixed%20neutral%20tones%2C%20high%20detail&width=600&height=400&seq=usfans-cat-other-v2&orientation=landscape&nocache=true",
    icon: "ri-more-line",
  },
];